import { render } from "./CoBrandArch.vue?vue&type=template&id=59324afa&scoped=true"
import script from "./CoBrandArch.vue?vue&type=script&lang=js"
export * from "./CoBrandArch.vue?vue&type=script&lang=js"

import "./CoBrandArch.vue?vue&type=style&index=0&id=59324afa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59324afa"]])

export default __exports__